<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getHwShipment,
  refShipments,
  saveCreateBill,
  cancelHangBill,
  updateItemsType,
  uploadFile,
  sync
} from "@/api/finance/hw_shipment_hq";
import { getConfig, client_hq } from "@/api/finance/shipment_hq";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import { getWarehouse } from "@/api/storage/warehouse";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
export default {
  name: "hw_shipment_hq",
  components: {
    cTable
  },
  data() {
    return {
      client_hq_list: [],
      hq_clients: [],
      methods: {
        list: data => {
          let params = JSON.parse(JSON.stringify(data));
          if (data.hq_client) {
            params.hq_client = this.client_hq_list.reduce((a, b) => {
              this.hq_clients.find(t => {
                if (t.value === b.uuid && t.label === b.account) {
                  a.push(b);
                  return true;
                }
              });
              return a;
            }, []);
          }
          return getHwShipment(params);
        },
        getAllClient,
        refShipments,
        getSelectType,
        saveCreateBill,
        updateItemsType,
        cancelHangBill,
        uploadFile,
        getConfig,
        sync
      },
      config: {
        height: 630,
        contentMethod({row, column}) {
          if (
            column.type == "calculate_status" &&
            row.financeInfo.calculate_msg
          ) {
            return row.financeInfo.calculate_msg;
          }
        },
        exportConfig({column}) {
          return ["financeInfo.quotation_name"].indexOf(column.property) === -1;
        }
      },
      modals: {
        reStatistics: {
          methods: {
            ok({row, close}) {
              let data = row;
              data.airway_number = this.$page.selectAll.map(item => ({
                target_type: item.target_type,
                airway_bill_number: item.airway_bill_number
              }));
              this.$page
                .handleRequestMethods("refShipments", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("reStatistics"),
            modalBind: {
              width: 400
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{use_charge_type: 24}],
          fields: [
            {
              name: this.$t("Billing") + this.$t("type"),
              key: "use_charge_type",
              component: "Radio",
              placeholder: () =>
                this.$t("select") + this.$t("Billing") + this.$t("type"),
              options: [],
              bind: {
                border: true
              },
              default: "charge_params",
              methods: {
                async list({field}) {
                  field.options = (await getConfig()).data.payload.weight_type;
                  this.$forceUpdate();
                }
              }
            }
          ]
        },
        add: {
          type: "add",
          methods: {
            ok: ({row, close}) => {
              let data = JSON.parse(JSON.stringify(row));
              let table = this.$refs["table"];
              data.ids = table.selectAll.map(item => item.airway_bill_number);
              if (data.hq_client) {
                data.hq_client = this.client_hq_list.reduce((a, b) => {
                  this.hq_clients.find(t => {
                    if (t.value === b.uuid && t.label === b.account) {
                      a.push(b);
                      return true;
                    }
                  });
                  return a;
                }, []);
              }
              table.openLoading();
              table.handleRequestMethods("saveCreateBill", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                table.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            {name: 24},
            {show_sku: 24},
            {target_type: 24},
            {remarks: 24}
          ],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("whether") + this.$t("show") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show") +
                "SKU",
              options: [
                {label: this.$t("YES"), value: 1},
                {label: this.$t("NO"), value: 0}
              ],
              default: 0,
              bind: {
                border: true
              }
            },
            {
              name: this.$t("CollectionUser"),
              key: "target_type",
              component: "Radio",
              placeholder: () => this.$t("select") + this.$t("CollectionUser"),
              options: [
                {label: this.$t("b2bClient"), value: 1},
                {label: this.$t("branchOffice"), value: 2}
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        feeModal: {
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("expense"),
                key: "expense_item_name",
                align: "center"
              },
              {
                name: this.$t("cost_t") + "(USD)",
                key: "amount_usd",
                align: "center"
              },
              {
                name: this.$t("cost_t") + "(CNY)",
                key: "amount_cny",
                align: "center"
              }
            ]
          }
        },
        showstatus: {
          contentSlot: "SHOWSTATUS"
        },
        update: {
          methods: {
            ok({row, close}) {
              let data = row;
              data.airway_number = this.$page.selectAll.map(
                item => item.airway_bill_number
              );
              this.$page
                .handleRequestMethods("updateItemsType", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("update") + this.$t("order_type_t"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              target_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{target_type: 24}],
          fields: [
            {
              name: () => this.$t("order_type_t"),
              key: "target_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              clearable: true,
              options: [],
              config: {},
              methods: {
                async list({field}) {
                  field.options = (
                    await getSelectType("ORDERS_TYPE")
                  ).data.payload["ORDERS_TYPE"];
                  this.$forceUpdate();
                }
              }
            }
            // {
            //   name: this.$t("Remarks"),
            //   key: "remarks",
            //   component: "Input",
            //   placeholder: () => this.$t("enter") + this.$t("Remarks"),
            //   bind: {
            //     type: "textarea",
            //     rows: 5
            //   }
            // }
          ]
        },
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl + "/excel/tmp/charge_weight_finance.xlsx"
              );
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("down") + this.$t("template")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("updateFile") + this.$t("files")
          },
          grid: [{files: 24}],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({file}) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            options: [
              {label: this.$t("outbound_time"), value: 2},
              {
                label: this.$t("inboundTime"),
                value: 3
              }
            ],
            bind: {
              style: "width:100px"
            },
            default: 2
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          {
            key: "deliver",
            placeholder() {
              return this.$tz("派送代理");
            },
            component: "Select",
            options: [],
            optionsFn: "getTransportAgent",
            optionsKey: "",
            config: {
              value: "label"
            }
          },
          {
            key: "from_country",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "type",
            component: "Select",
            placeholder() {
              return this.$t("order_type_t");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:140px"
            },
            config: {},
            methods: {
              async list({field}) {
                field.options = (
                  await getSelectType("ORDERS_TYPE")
                ).data.payload["ORDERS_TYPE"];
                this.$forceUpdate();
              }
            }
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              {label: this.$t("b2bClient"), value: 1},
              {label: this.$t("branchOffice"), value: 2}
            ]
          },
          {
            key: "hq_client",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("HQClient");
            },
            clearable: true,
            options: [],
            default: [],
            config: {label: "account", value: "uuid"},
            bind: {
              style: "width:200px",
              multiple: true,
              "max-tag-count": 1,
              "label-in-value": true
            },
            methods: {
              "on-change": data => {
                this.hq_clients = data._value;
              }
            }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: {label: "account", value: "id"}
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("expType");
            },
            clearable: true,
            options: [
              {label: this.$t("billFailed"), value: 0},
              {
                label: this.$t("billSuccess"),
                value: 1
              }
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            clearable: true,
            options: [],
            config: {label: "title", value: "id"},
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("codTypes");
            },
            clearable: true,
            options: [
              {label: this.$t("noOrder"), value: 0},
              {label: this.$t("isOrder"), value: 1},
              {label: this.$t("objection"), value: 3},
              {label: this.$t("Settled"), value: 9}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "warehouse_operate",
            placeholder() {
              return this.$tz("海外仓,是否,操作");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNo",
            optionsKey: ""
          },
          {
            key: "trace_flag",
            placeholder() {
              return this.$tz("POD");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "TRACE_FLAG"
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("reStatistics"),
              type: "reStatistics",
              fnName: "reStatistics",
              bind: {
                type: "warning",
                icon: "md-refresh"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("cancel") + this.$t("hang"),
              type: "cancelHang",
              fnName: "cancelHang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-arrow-down",
                type: "warning"
              }
            },
            {
              name: () =>
                this.$t("update") + this.$t("order_t") + this.$t("type"),
              type: "update",
              fnName: "update",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () =>
                this.$t("update") +
                this.$t("Billing") +
                this.$t("invoiceWeight"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary"
              }
            }
          ],
          methods: {
            sync() {
              this.openLoading();
              this.handleRequestMethods("sync").then(res => {
                this.closeLoading();
                this.getList();
              });
            },
            upload() {
              this.getModal("upload").open();
            },
            add({searchForm}) {
              this.getModal("add").open(searchForm);
            },
            async export({searchForm}) {
              let data = searchForm;
              data.export = 1;
              data.ids = this.selectAll.map(item => item.airway_bill_number);
              this.handleRequestMethods("list", data, true, true).then(res => {
                console.log(res);
                window.open(this.$globalUrl + res.payload.src);
              });
            },
            reStatistics() {
              this.getModal("reStatistics").open();
            },
            cancelHang() {
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    ids: this.selectAll.map(item => {
                      return item.id;
                    })
                  };
                  this.handleRequestMethods("cancelHangBill", data).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            },
            update() {
              this.getModal("update").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("order_t") + this.$t("type"),
          key: "type",
          width: 120
        },
        {
          name: () => this.$t("CollectionUser"),
          key: "target_type_txt",
          width: 100
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          width: 100
        },
        {
          name: () => this.$tz("海外仓,是否,操作"),
          key: "warehouse_operate",
          minWidth: 110
        },
        {
          name: () => this.$t("customsBill"),
          key: "str1",
          width: 120
        },
        {
          name: () => this.$t("mawb"),
          key: "str2",
          width: 120
        },
        {
          name: () => this.$t("cross_port") + this.$t("agentT"),
          key: "str3",
          width: 120
        },
        {
          name: () => this.$t("clearagent"),
          key: "str4",
          width: 120
        },
        {
          name: () => this.$t("air_agent"),
          key: "str5",
          width: 120
        },
        {
          name: () => this.$t("Order channel"),
          key: "shipment.init_agent",
          width: 120
        },
        {
          name: () => this.$t("distribution_agent"),
          key: "shipment.deliver",
          width: 120
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 120
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 120
        },
        {
          name: () => this.$t("trajectory"),
          width: 95,
          key: "trace",
          children: [
            {
              name: () => this.$t("code"),
              key: "shipment.trace_code",
              width: 95
            },
            {
              name: () => this.$t("deSc"),
              key: "shipment.trace_remarks",
              width: 110
            },
            {
              name: () => this.$t("upTime"),
              key: "shipment.trace_time",
              width: 150
            }
          ]
        },
        {
          name: () => this.$t(this.$t("clientName")),
          key: "clientInfo.account",
          width: 95
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130
        },
        {
          name: () => this.$t("shipperRef"),
          key: "shipment.client_refer_code",
          width: 95
        },
        {
          name: () => this.$t("transfer_num"),
          key: "shipment.agent_refer_code",
          width: 95
        },
        {
          name: () => this.$t("DeliveryMode"),
          key: "shipment.delivery_mode",
          minWidth: 100
        },
        {
          name: () => this.$t("salesman"),
          width: 95,
          key: "clientInfo.salesman.account"
        },
        {
          name: () => this.$t("DDX"),
          key: "shipment.ddx",
          width: 80
        },
        {
          name: () => this.$t("channel_code"),
          key: "shipment.transport_mode",
          width: 95
        },
        {
          name: () => this.$t("allow_depart"),
          key: "shipment.from_country",
          width: 95
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "shipment.to_country",
          width: 95
        },
        {
          name: () => this.$t("city_name"),
          key: "shipment.city_name",
          width: 95
        },
        {
          name: () => this.$t("remote_regions"),
          key: "shipment.remote_areas_txt",
          width: 110
        },
        {
          name: () => this.$t("order_goods"),
          key: "goods_count",
          width: 100
        },
        {
          name: () => this.$t("actual_weight"),
          key: "financeInfo.actual_weight",
          width: 95
        },
        {
          name: () => this.$t("charge_volume"),
          key: "financeInfo.charge_volume",
          width: 95
        },
        {
          name: () => this.$t("charge_params"),
          key: "financeInfo.charge_params",
          width: 95
        },

        {
          name: () =>
            this.$t("charge_params") + "(" + this.$t("finances") + ")",
          key: "financeInfo.charge_weight_finance",
          width: 95
        },
        {
          name: () => this.$t("charge_params") + this.$t("type"),
          key: "financeInfo.use_charge_type",
          width: 95
        },

        {
          name: () => this.$t("actual_receipt") + this.$t("freight_fees"),
          width: 110,
          children: ["cny", "usd", "sar", "qar", "aed", "kwd"].map(t => {
            let data = {
              name: t.toUpperCase(),
              key: "financeInfo.freight_fees_" + t,
              width: 95
            };
            return data;
          })
        },
        {
          name: () => this.$t("freight_fees") + this.$t("VATFee"),
          key: "financeInfo.freight_vat_fee",
          width: 95
        },
        {
          name: () => this.$t("actual_receipt") + this.$t("freight_fees"),
          key: "financeInfo.total_freight",
          width: 95
        },
        {
          name: () => this.$t("otherCost"),
          width: 110,
          key: "remote_fee",
          children: [
            {
              name: this.$t("remote_regions_fee"),
              key: "remote_fee_",
              child: ["cny", "usd"]
            },
            {
              name: this.$t("freight_append"),
              key: "other_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"],
              childBind: {
                noDeep: true,
                render: (h, {row, field}) => {
                  return h(
                    "Button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary"
                      },
                      on: {
                        click: () => {
                          this.$refs["table"]
                            .getModal("feeModal")
                            .open({row}, function () {
                              this.setTitle(
                                this.$t("freight_append") +
                                "(" +
                                row.airway_bill_number +
                                ")"
                              );
                              this.list = row.financeInfo.otherFeeItem;
                            });
                        }
                      }
                    },
                    row.financeInfo["other_fee_" + field.data]
                  );
                }
              }
            },
            {
              name: this.$t("overweight_fee"),
              key: "ext_overweight_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"]
            },
            {
              name: this.$t("overload_fee"),
              key: "ext_overload_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"]
            },
            {
              name: this.$t("extra_charge"),
              key: "ext_op_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"]
            },
            {
              name: this.$t("material_fee"),
              key: "ext_material_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"]
            }
          ].map(t => {
            let data = {
              name: t.name,
              key: t.key,
              width: 110,
              children: []
            };
            data.children = t.child.map(c => {
              return {
                name: c.toUpperCase(),
                key: "financeInfo." + t.key + c,
                width: 95,
                data: c,
                ...t.childBind
              };
            });
            console.log(data.children, "t");
            return data;
          })
        },
        {
          name: () => this.$t("taxFee") + " USD",
          width: 110,
          children: [
            {
              name: this.$t("total_tax"),
              key: "financeInfo.total_tax_usd",
              width: 95
            },
            {
              name: this.$t("vat_fee") + " VAT",
              key: "financeInfo.vat_fee_usd",
              width: 95
            },
            {
              name: this.$t("tax_fee") + " Duty",
              key: "financeInfo.tax_fee_usd",
              width: 95
            },
            {
              name: this.$t("document_fee"),
              key: "financeInfo.document_fee_usd",
              width: 95
            }
          ]
        },
        {
          name: () => this.$t("to") + this.$t("rate"),
          width: 110,
          children: [
            "freight_unit",
            "cny",
            "usd",
            "sar",
            "qar",
            "aed",
            "kwd"
          ].map(t => {
            let data = {
              name:
                t === "freight_unit" ? this.$t("toCurrency") : t.toUpperCase(),
              key: "financeInfo." + (t === "freight_unit" ? t : t + "_to_rate"),
              width: 95
            };
            return data;
          })
        },
        {
          name: () => this.$t("receivable") + this.$t("total"),
          key: "financeInfo.total_amount",
          minWidth: 110
        },
        {
          name: () => this.$t("COD"),
          width: 95,
          children: [
            {
              name: () => this.$t("currency_t"),
              key: "shipment.cod_currency",
              width: 95
            },
            {
              name: () => this.$t("reChAmount"),
              key: "shipment.cod_amount",
              width: 95
            }
          ]
        },
        {
          name: () => this.$t("bill_type"),
          key: "financeInfo.finance_status_txt",
          width: 80,
          methods: {
            render({row}) {
              return row.financeInfo.finance_status_txt;
            }
          }
        },
        {
          name: () => this.$t("bill_number"),
          key: "financeInfo.bill_number",
          width: 110,
          noDeep: true,
          render: (h, {row}) => {
            if (row.financeInfo) {
              return h(
                "a",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$refs["table"].toPage(
                        "hw_bill_hq",
                        row.financeInfo.bill_number
                      );
                    }
                  }
                },
                row.financeInfo.bill_number
              );
            }
          }
        },
        {
          name: () => this.$t("bindFreight"),
          key: "financeInfo.quotation_name",
          align: "left",
          width: 95
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "shipment.values",
          width: 95
        },
        {
          name: () => this.$t("exlType"),
          key: "financeInfo.calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          fixed: "right",
          bind: {
            style({row}) {
              return {
                color:
                  row.financeInfo.calculate_status == 1 ? "#4caf50" : "#f44336"
              };
            }
          },
          methods: {
            render: ({row}) => {
              return row.financeInfo.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            }
          }
        }
      ]
    };
  },
  async mounted() {
    let fromCountry = (await getCountry({allow_depart: 1})).data.payload.rows;
    let toCountry = (await getCountry({allow_arrive: 1})).data.payload.rows;
    this.header.searchs.forEach(async item => {
      if (item.key == "salesman_id") {
        item.options = (
          await getUser({standard: "Salesman"})
        ).data.payload.rows;
      }
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
      if (item.key === "hq_client")
        this.client_hq_list = item.options = (await client_hq()).data.payload;
    });
  }
};
</script>
